/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EntityHintLevel = typeof EntityHintLevel[keyof typeof EntityHintLevel];


export const EntityHintLevel = {
  job: 'job',
  job_candidate: 'job_candidate',
} as const;
